import { EventEmitter } from "events";
import { IBackupViewData } from "../../../models/BackupAndRestore/BackupViewData";
import LMSDispatcher from "../../LMSDispatcher";
import * as ACTIONCONSTANTS from "../../actions/ActionConstants";
import * as CONSTANTS from '../../../utilities/Constants';

interface IBackupAndRestoreList {
    state: {
        data: IBackupViewData[]
    }
}

class ListStore extends EventEmitter implements IBackupAndRestoreList {
    state: { 
        data: IBackupViewData[]; 
    };

    constructor() {
        super()

        this.state = {
            data: []
        };

        LMSDispatcher.register((e: any) => {
            switch (e.type) {
                case ACTIONCONSTANTS.BACKUP_AND_RESTORE_GET_ALL:
                    Object.assign(this.state, e.payload);
                    this.emit(CONSTANTS.CHANGE_EVENT, this.state);
                    break;
            }
        });
    }
}

const backupAndRestoreListStore = new ListStore();
export default backupAndRestoreListStore